import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import CbtType from '../pages/cbt/type';
import CbtTypeCreate from '../pages/cbt/type/create';
import CbtTypeEdit from '../pages/cbt/type/edit';
import CbtTypeSubject from '../pages/cbt/type/subject';
import CbtPrt from '../pages/cbt/prt';
import CbtPt from '../pages/cbt/pt';
import CbtClass from '../pages/cbt/class';
import CbtTest from '../pages/cbt/test';
import CbtSpeakingItem from '../pages/cbt/speaking-item';
import CbtSpeakingItemCreate from '../pages/cbt/speaking-item/create';
import CbtSpeakingItemEdit from '../pages/cbt/speaking-item/edit';
import CbtSpeakingTest from '../pages/cbt/speaking-test';
import CbtSpeakingTestPreview from '../pages/cbt/speaking-test/preview';
import CbtSpeakingTestExam from '../pages/cbt/speaking-test/exam';
import CbtSpeakingTestCreate from '../pages/cbt/speaking-test/create';
import CbtSpeakingTestEdit from '../pages/cbt/speaking-test/edit';
import CbtSpeakingTestPartCreate from '../pages/cbt/speaking-test/part/create';
import CbtSpeakingTestPartEdit from '../pages/cbt/speaking-test/part/edit';
import CbtSpeakingRubric from '../pages/cbt/speaking-rubric';
import CbtSpeakingRubricCreate from '../pages/cbt/speaking-rubric/create';
import CbtSpeakingRubricEdit from '../pages/cbt/speaking-rubric/edit';
import CbtSpeakingRubricRead from '../pages/cbt/speaking-rubric/read';

const CbtRouter: FC = () => {
  return (
    <Switch>
      <Route path="/cbt/type" exact component={CbtType} />
      <Route path="/cbt/type/create" exact component={CbtTypeCreate} />
      <Route path="/cbt/type/:id/edit" exact component={CbtTypeEdit} />
      <Route path="/cbt/type/:id/subject" exact component={CbtTypeSubject} />
      <Route path="/cbt/prt" exact component={CbtPrt} />
      <Route path="/cbt/pt" exact component={CbtPt} />
      <Route path="/cbt/class" exact component={CbtClass} />
      <Route path="/cbt/test" exact component={CbtTest} />
      <Route path="/cbt/speaking-item" exact component={CbtSpeakingItem} />
      <Route
        path="/cbt/speaking-item/create"
        exact
        component={CbtSpeakingItemCreate}
      />
      <Route
        path="/cbt/speaking-item/:id/edit"
        exact
        component={CbtSpeakingItemEdit}
      />
      <Route path="/cbt/speaking-rubric" exact component={CbtSpeakingRubric} />
      <Route
        path="/cbt/speaking-rubric/create"
        exact
        component={CbtSpeakingRubricCreate}
      />
      <Route
        path="/cbt/speaking-rubric/:id/edit"
        exact
        component={CbtSpeakingRubricEdit}
      />
      <Route
        path="/cbt/speaking-rubric/:id"
        exact
        component={CbtSpeakingRubricRead}
      />
      <Route path="/cbt/speaking-test" exact component={CbtSpeakingTest} />
      <Route
        path="/cbt/speaking-test/create"
        exact
        component={CbtSpeakingTestCreate}
      />
      <Route
        path="/cbt/speaking-test/preview/:speakingExamCode"
        exact
        component={CbtSpeakingTestPreview}
      />
      <Route
        path="/cbt/speaking-test/exam"
        exact
        component={CbtSpeakingTestExam}
      />
      <Route
        path="/cbt/speaking-test/:id/edit"
        exact
        component={CbtSpeakingTestEdit}
      />
      <Route
        path="/cbt/speaking-test/:id/part/create"
        exact
        component={CbtSpeakingTestPartCreate}
      />
      <Route
        path="/cbt/speaking-test/:id/part/:subid/edit"
        exact
        component={CbtSpeakingTestPartEdit}
      />
    </Switch>
  );
};

export default CbtRouter;
